// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const stakataka: PokeData = {
  "id": 805,
  "name": "stakataka",
  "height": 55,
  "weight": 8200,
  "base_experience": 257,
  "types": [
    PokeType.ROCK,
    PokeType.STEEL
  ],
  "api_moves": [
    "stomp",
    "tackle",
    "take-down",
    "double-edge",
    "rock-throw",
    "harden",
    "bide",
    "rock-slide",
    "protect",
    "iron-defense",
    "block",
    "rock-blast",
    "magnet-rise",
    "iron-head",
    "stealth-rock",
    "wide-guard",
    "autotomize"
  ],
  "moves": [
    "tackle",
    "rock-throw",
    "rock-slide",
    "protect",
    "rock-blast",
    "stealth-rock",
    "magnet-pull",
    "meteor-mash",
    "smart-strike",
    "rock-tomb",
    "gear-up",
    "iron-defense",
    "stone-crush"
  ],
  "evolution_chain": {
    "id": 425,
    "item": null,
    "species": [
      {
        "name": "stakataka",
        "order": 805,
        "types": [
          PokeType.ROCK,
          PokeType.STEEL
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      }
    ]
  },
  "stats": {
    "resistance": 172,
    "speed": 21,
    "ability_power": 208
  },
  "stat_changes": [],
  "catch_rate": 30,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
